import {ToolsServices} from "./services";
import {ToolsConstants} from "./constants";

export const ToolsActions = {
    generateMarkIdPayload,
    getCompanyNames,
    clearAllPayload,
    startOndatoIdentification
};

function generateMarkIdPayload(data) {
    return dispatch => {
        dispatch(request());

        return ToolsServices.generateMarkIdPayload(data)
            .then(
                data => dispatch(success(data)),
                error => dispatch(failure(error))
            )
    };

    function request() {
        return {type: ToolsConstants.POST_GENERATE_MARK_ID_PAYLOAD_REQUEST}
    }

    function success(data) {
        return {type: ToolsConstants.POST_GENERATE_MARK_ID_PAYLOAD_SUCCESS, payload: data};
    }

    function failure(error) {
        return {type: ToolsConstants.POST_GENERATE_MARK_ID_PAYLOAD_ERROR, error};
    }
}

function getCompanyNames() {
    return dispatch => {
        dispatch(request());

        return ToolsServices.getCompanyNames()
            .then(
                data => dispatch(success(data)),
                error => dispatch(failure(error))
            )
    };

    function request() {
        return {type: ToolsConstants.GET_COMPANY_NAMES_REQUEST}
    }

    function success(data) {
        return {type: ToolsConstants.GET_COMPANY_NAMES_SUCCESS, payload: data};
    }

    function failure(error) {
        return {type: ToolsConstants.GET_COMPANY_NAMES_ERROR, error};
    }
}

function startOndatoIdentification(data) {
    return dispatch => {
        dispatch(request());

        return ToolsServices.startOndatoIdentification(data)
            .then(
                data => dispatch(success(data)),
                error => dispatch(failure(error))
            )
    };

    function request() {
        return {type: ToolsConstants.POST_START_ONDATO_IDENTIFICATION_REQUEST}
    }

    function success(data) {
        return {type: ToolsConstants.POST_START_ONDATO_IDENTIFICATION_SUCCESS, payload: data};
    }

    function failure(error) {
        return {type: ToolsConstants.POST_START_ONDATO_IDENTIFICATION_ERROR, error};
    }
}

function clearAllPayload() {
    return dispatch => {
        dispatch({type: ToolsConstants.CLEAR_ALL_PAYLOAD});
    };
}